import { classNames } from "primereact/utils";
import styles from "./WizardNavigation.module.scss";
import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import { WizardStep } from "../../models";

interface IWizardNavigationProps {
  className?: string;
  currentStep: WizardStep;
  canNavigateBack: boolean;
  canNavigateForward: boolean;
  isLoading?: boolean;
  validationMessage?: string;
  onBack: () => void;
  onForward: () => void;
  onMenuClick?: () => void;
}

export const WizardNavigation = ({
  className,
  currentStep,
  canNavigateBack,
  canNavigateForward,
  isLoading = false,
  validationMessage,
  onBack,
  onForward,
}: IWizardNavigationProps) => {
  // Get button text based on current step
  const getForwardButtonText = (): string => {
    switch (currentStep) {
      case "start":
        return "Запази час";
      case "services":
        return "Продължи";
      case "employees":
        return "Продължи";
      case "datetime":
        return "Продължи";
      case "confirmation":
        return "Потвърди";
      default:
        return "Продължи";
    }
  };

  const getBackButtonText = (): string => {
    return "Назад";
  };

  // Don't render navigation on success step or start step (has its own action button)
  if (currentStep === "success" || currentStep === "start") {
    return null;
  }

  return (
    <div className={classNames(styles.navigation, className)}>
      {/* Validation Message */}
      {validationMessage && (
        <div className={styles.validationMessage}>{validationMessage}</div>
      )}

      {/* Navigation Buttons */}
      <div className={styles.buttonGroup}>
        {canNavigateBack && (
          <DefaultButton
            className={styles.backButton}
            design="neutral"
            label={getBackButtonText()}
            onClick={onBack}
            disabled={isLoading}
            width="100%"
          />
        )}

        <DefaultButton
          className={styles.forwardButton}
          design="accent"
          label={getForwardButtonText()}
          onClick={onForward}
          disabled={!canNavigateForward || isLoading}
          loading={isLoading}
          width="100%"
        />
      </div>
    </div>
  );
};
